import axios from 'axios';

const BASE_URL = '/app/httpRequestFunnel/requests';

export const createHttpRequest = async () => {
    const { data } = await axios.post(`${BASE_URL}`);

    return data;
};

export const mapHttpTypeInfoToHttpTypeList = async (httpTypeInfoList) => {
    const requestCallTypes = [];

    Object.keys(httpTypeInfoList).forEach((key) => {
        if (httpTypeInfoList[key]) {
            requestCallTypes.push({ label: httpTypeInfoList[key], value: key });
        }
    });

    return requestCallTypes;
};

export const getHttpRequestCallType = async () => {
    const { data } = await axios.get(`${BASE_URL}/get-http-request-call-type`);

    return mapHttpTypeInfoToHttpTypeList(data);
};

export const getHttpRequestConfig = async (httpRequestConfigId) => {
    const { data } = await axios.get(`${BASE_URL}/get-http-request-config/${httpRequestConfigId}`);

    return data;
};

export const saveHttpRequestConfig = async (httpRequestConfigId, payload) => {
    const { data } = await axios.post(`${BASE_URL}/${httpRequestConfigId}/save`, payload);

    return data;
};

export const saveOrUpdateHttpRequestParameter = async (httpRequestConfigId, payload) => {
    const data = await axios.post(`${BASE_URL}/${httpRequestConfigId}/save-or-update-http-request-parameter`, payload);

    return data;
};

export const deleteRequestParameter = async (httpRequestParameterId) => {
    const data = await axios.delete(`${BASE_URL}/params/delete/?httpRequestParameterId=${httpRequestParameterId}`);

    return data;
};

export const testHttpRequest = async (payload) => {
    const { data } = await axios.post(`${BASE_URL}/v2/test`, payload);

    return data;
};

export const getAuthorsMenus = async () => {
    const { data } = await axios.get(`${BASE_URL}/authoring-test-menu`);

    return data;
};


export const getFilteredHttpRequestCampaigns = async () => {
    const { data } = await axios.get(`${BASE_URL}/authoring-copy-campaign`);

    return data;
};

export const getHttpRequestFunnel = async (payload) => {
    const {
        value,
        identifierName = 'style',
        identifierValue = 'httpRequest',
        idAttributeName = 'httpRequestConfigId',
        idAttributeValue = null,
        filterAttributeName = null,
        filterAttributeValue = null,
        filterAttributeRequired = null,
    } = payload;

    const { data } = await axios.get(`${BASE_URL}/load-for-funnel?value=${value}&identifierName=${identifierName}&identifierValue=${identifierValue}&idAttributeName=${idAttributeName}&idAttributeValue=${idAttributeValue}&filterAttributeName=${filterAttributeName}&filterAttributeValue=${filterAttributeValue}&filterAttributeRequired=${filterAttributeRequired}`);

    return data;
};

export const saveCopyFromCampaign = async (httpRequestConfigId, templateId) => {
    const { data } = await axios.put(`/app/httpRequestFunnel/${httpRequestConfigId}/copyFrom`, JSON.stringify(templateId), {
        headers: {
            'Content-Type': 'application/json',
        },
    });

    return data;
};
